import { getProfileAPI } from "@/services";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getProfile = createAsyncThunk(
  "profile/createAsyncThunk",
  async () => {
    try {
      const { data } = await getProfileAPI();
      return data;
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);
